// extracted by mini-css-extract-plugin
var _1 = "ZD1Y_";
var _2 = "PSQMZ";
var _3 = "grDeM";
export { _1 as "level-error", _2 as "level-info", _3 as "level-warning" }
